import SubdirectoryArrowRightOutlined from '@mui/icons-material/SubdirectoryArrowRightOutlined';
import Stack from '@mui/material/Stack';
import { Link } from '@openx/components-core/lib/Link/Link';
import type { OrganizationData, OrganizationsList } from '@openx/types/organization';
import { useMemo } from 'react';
import { buildOrganizationHierarchy } from './utils';

export type AccountHierarchyProps = {
  parentOrganizationsData: OrganizationsList[];
  organization: OrganizationData;
};

export const AccountHierarchy = ({ parentOrganizationsData, organization }: AccountHierarchyProps) => {
  const organizationHierarchy = useMemo(
    () => buildOrganizationHierarchy(organization, parentOrganizationsData),
    [organization, parentOrganizationsData]
  );

  return (
    <Stack direction="column" spacing={1} sx={{ borderLeft: theme => `2px solid ${theme.palette.divider}`, pl: 2 }}>
      {organizationHierarchy.map(item => (
        <Stack
          key={item.id}
          direction="row"
          spacing={0}
          sx={{
            alignItems: 'center',
            mt: '0 !important',
            overflowWrap: 'anywhere',
            pl: item.depth > 1 ? (item.depth - 1) * 2.5 : 0,
          }}
        >
          {item.depth > 0 && <SubdirectoryArrowRightOutlined color="action" fontSize="small" />}
          <Link to={`/organizations/${item.id}/details`} isDisabled={item.id === organization.id}>
            {item.name}
          </Link>
        </Stack>
      ))}
    </Stack>
  );
};
